export default __webpack_public_path__ + "static/media/Qualitas-color.18aee026.svg";